import get from 'lodash/get';
import api from '../api.service';
import queryString from "query-string"

class ActionApi {

    /**
     * @param planItemId
     * @param actionData
     * @param [options]
     * @return {Promise<*>}
     */
    createAction(planItemId, actionData, options = {}) {
        const qs = queryString.stringify(options || {});
        return api.post(`/mission-plan/${planItemId}/action?${qs}`, actionData)
            .then(res => res.data)
            .catch(err => {
                throw get(err || {}, 'response.data') || err
            })
    }

    updateAction(actionId, actionData) {
        return api.put(`/action/${actionId}`, actionData)
            .then(res => res.data)
            .catch(err => {
                throw get(err || {}, 'response.data') || err
            })
    }

    // Confirms a % on a work package billed by % complete: { pct, asOf }. Append-only
    addBillingProgress(actionId, entry) {
        return api.post(`/action/${actionId}/billing-progress`, entry)
            .then(res => res.data)
            .catch(err => {
                throw get(err || {}, 'response.data') || err
            })
    }

    updateActionBulk(missionId, actions) {
        return api.put(`/action/${missionId}/bulk`, actions)
            .then(res => res.data)
            .catch(err => {
                throw get(err || {}, 'response.data') || err
            })
    }

    /**
     * @param actionId
     * @param [options]
     * @param [options.moveTo] {string} Action to move the tasks to instead of deleting them
     *   (board sections move theirs to the catch-all on their own)
     * @return {Promise<{movedTo?: {_id, missionPlanId, actionItems: string[]}}>}
     */
    deleteAction(actionId, options = {}) {
        const qs = queryString.stringify(options || {});
        return api.delete(`/action/${actionId}${qs ? `?${qs}` : ''}`)
            .then((res) => res?.data || {})
            .catch(err => {
                throw get(err || {}, 'response.data') || err
            })
    }

    addActionDependency(actionId, dependencyActionId) {
        return api.put(`/action/${actionId}/dependency/add`, {actionId: dependencyActionId})
            .then(res => res.data)
            .catch(err => {
                throw get(err || {}, 'response.data') || err
            })
    }

    removeActionDependency(actionId, dependencyActionId) {
        return api.put(`/action/${actionId}/dependency/remove`, {actionId: dependencyActionId})
            .then(res => res.data)
            .catch(err => {
                throw get(err || {}, 'response.data') || err
            })
    }

    /**
     * EXAMPLE:
     * apiAction.onChanges('update', data => console.log(data))
     * @param operation {string} - update, create or delete
     */
    async onChanges(operation, query, cb) {

        if (typeof query === 'function') {
            cb = query
            query = {}
        }

        const socket = await api.socket.connect(`changes/actions/${operation}`, {
            query
        })

        socket.on('changes', cb)
    }

}

export default new ActionApi();
